module.exports = __webpack_public_path__ + "images/logo.png?b1565f519c34735b3b99c094925f4692";